import { useEffect, useState } from 'react';
import { useToastStore } from '../zustand/store';

const Toast = () => {
    const { toastMessage, isToastVisible, setIsToastVisible } = useToastStore();
    const [isAnimating, setIsAnimating] = useState(false);

    useEffect(() => {
        if (isToastVisible) {
            // start slide-in animation
            setIsAnimating(true);
            
            // duration 2000ms
            setTimeout(() => {
                setIsAnimating(false);
                // wait for slide-out animation before hiding
                setTimeout(() => {
                    setIsToastVisible(false);
                }, 150);
            }, 2000);
        }
    }, [isToastVisible, setIsToastVisible]);

    if (!toastMessage || !isToastVisible) return null;

    return (
        <div
            style={{
                position: 'fixed',
                display: 'inline-flex',
                padding: '10px 14px',
                justifyContent: 'center',
                alignItems: 'center',
                borderRadius: '4px',
                background: '#222',
                bottom: '304px',
                left: '50%',
                transform: isAnimating 
                    ? 'translateX(-50%) translateY(0)' 
                    : 'translateX(-50%) translateY(50px)',
                transition: 'transform 150ms ease-in-out, opacity 150ms ease-in-out',
                zIndex: 100,
                opacity: isAnimating ? 1 : 0,
            }}
        >
            <p className="h6 fc-gray-100">{toastMessage}</p>
        </div>
    )
}

export default Toast;